var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#0EC06B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_7705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5005 41.6L27.8338 36.9333C27.3138 36.4133 26.4871 36.4133 25.9671 36.9333C25.4471 37.4533 25.4471 38.28 25.9671 38.8L31.5538 44.3867C32.0738 44.9067 32.9138 44.9067 33.4338 44.3867L47.5671 30.2667C48.0871 29.7467 48.0871 28.92 47.5671 28.4C47.0471 27.88 46.2205 27.88 45.7005 28.4L32.5005 41.6Z",
    fill: "#0EC06B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_7705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20.5 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDone);
export default __webpack_public_path__ + "static/media/IconCheckDone.ef2e7780f6972b233a685f8705222fbd.svg";
export { ForwardRef as ReactComponent };